import { hooks } from '@/store.js';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'sonner';

export default function SyncIcon({ onSync }: { onSync: () => void }) {
  const onLine = hooks.useSyncStatus();
  const client = hooks.useClient();

  const [syncing, setSyncing] = useState(false);

  return (
    <i
      className={`ic-outline mr-3 animate__animated ${
        syncing
          ? 'md-sync spin-infinite'
          : `${onLine ? 'md-cloud_sync ' : 'md-sync_disabled'}`
      }`}
      onClick={() => {
        if (!onLine) return;

        setSyncing(true);
        toast.promise(client.sync.syncOnce, {
          // loading: "同步中...",
          success: (data) => '同步成功',
          error: 'Error',
          finally() {
            setSyncing(false);
            onSync();
          },
        });
      }}
    />
  );
}
